import { useReactiveVar } from '@apollo/client';

import { userStateVar } from 'core/state/userState';
import { UserRole } from 'types';

/**
 * Capability booleans for the PandaDoc screens, derived from the current
 * user's roles. Mirrors `useTeacherPermissions`. Hiding a control is a UX
 * affordance only — the backend remains the authority on each mutation.
 */
export interface IPandadocPermissions {
  /**
   * Run the repair pass (re-parse signer data on the whole cached inventory,
   * re-pull details where needed). Admin-only: a run can queue the entire
   * inventory for a `/details` re-fetch, costing hours of the PandaDoc
   * rate-limit budget. The plain sync stays open to every PandaDoc role.
   */
  canReparse: boolean;
}

// Mirror the BACKEND role gates exactly — a mismatch shows a control the
// backend then denies (silent failure / misleading empty state).
// pandadoc/schema/schema.py: PANDADOC_REPAIR_ROLES.
const PANDADOC_REPAIR_ROLES = [UserRole.ADMIN];

export const usePandadocPermissions = (): IPandadocPermissions => {
  const userState = useReactiveVar(userStateVar);
  const roles = (userState.me?.roles ?? []) as UserRole[];

  return {
    canReparse: roles.some((role) => PANDADOC_REPAIR_ROLES.includes(role)),
  };
};
